module.exports = __webpack_public_path__ + "static/media/Deborshi Goswami.632d52a9.png";